<template>
  <div class="w-full h-full flex md:flex-row flex-col items-center">
    <div class="lg:w-6/12 flex flex-col h-full">
      <div class="w-full my-auto text-center md:text-left">
        <section class="mb-4">
          <h1>
            <span
              class="text-title-sm leading-none md:leading-none"
              v-html="page.titolo2"
            />
          </h1>
        </section>
        <section class="mb-4 prose">
          <p><b>Per i nuovi clienti: interessi senza vincoli, sempre.</b></p>
          <p>
            Apri ControCorrente, con il pacchetto Semplice hai:
          </p>
          <ul
            class="list-disc list-inside text-center sm:list-none sm:text-left"
          >
            <li><b>Canone zero</b> accreditando lo stipendio o la pensione</li>
            <li><b>Carta di debito gratis</b> fino al 31/12/2027</li>
            <li>4 prelievi e 4 bonifici al mese inclusi</li>
          </ul>
          <p>E in più, <b>partecipa al programma fedeltà IBL Club</b>:</p>
          <ul
            class="list-disc list-inside text-center sm:list-none sm:text-left"
          >
            <li>
              Accredita lo stipendio o la pensione e puoi vincere un viaggio a
              Parigi per quattro persone.
            </li>
            <li>
              Presenta un amico che apre un conto e accredita, 100€ in gift card
              per entrambi.
            </li>
          </ul>
        </section>
        <section class="mb-4">
          <div class="flex flex-wrap md:-mx-2 justify-center md:justify-start">
            <app-cta-button
              class="w-min whitespace-nowrap"
              external
              :text="'APRI IL CONTO'"
              :link="apriContoUrl"
              :button-style="'brand'"
            />
            <app-cta-button
              class="w-min whitespace-nowrap"
              :text="'SCOPRILO'"
              link="/quanto/pacchetti"
              :button-style="'brand'"
            />
          </div>
        </section>
        <section class="mb-4 prose" v-html="page.descrizione" />
        <section class="mb-4">
          <p class="flex items-center" v-if="page.claim">
            <span
              >{{ page.claim.text }}
              <img class=" h-7 inline-block pb-1" :src="page.claim.logo" />
            </span>
          </p>
        </section>
      </div>
    </div>
    <div class="flex flex-col md:w-1/2">
      <img
        class="object-contain"
        src="assets/Desktop/1_HomePage/IBL_Conto_Vincolato_Sito_Slider.png"
      />
      <p
        class="text-xs md:text-sm text-center -mt-10 leading-tight max-w-xs mx-auto"
      >
        Promozione valida per i nuovi clienti che aprono il conto dal 01/11/2026
        al 18/11/2026 e attivano il vincolo entro il 31/12/2026. Rivolgersi alla
        filiale di riferimento. Per il programma fedeltà e come ottenere le gift
        card
        <a
          href="https://www.iblbanca.it/-/media/project/ibl/corporate/documenti/trasparenza/regolamenti-manifestazioni-a-premi/IBL_Club-Informativa_Legale_e_Regolamenti.pdf"
          target="_blank"
          class="underline cursor-pointer"
          >consulta qui il Regolamento.</a
        >
      </p>
    </div>
  </div>
</template>

<script>
// import { computed, ref } from "vue";
import { axios } from "@/plugins/axios";
import AppCtaButton from "@/components/nav/AppCtaButton";

export default {
  components: { AppCtaButton },
  data: () => ({
    megaPromoDate: new Date()
  }),
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent/home.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  },
  async mounted() {
    try {
      const response = await this.axios.get(
        `${process.env.VUE_APP_PLUGIN_GENERAL_API}/client-settings`
      );

      this.megaPromoDate = new Date(
        response.data.data.MegaPromoRequestableUntil.slice(0, -1)
      );

      this.megaPromoDate = this.megaPromoDate.toLocaleDateString("it-IT", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });
    } catch (error) {
      error;
    }
  }
};
</script>

<route>
{
  "name": "home",
  "meta": {
    "label": " ",
      "order": 0
  }
}
</route>
